import { Download } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { CSVLink } from 'react-csv'
import { type Headers } from 'react-csv/lib/core'

import { IconButton } from 'slab'
import { useGetPartnersPartnerIdPayoutsIdEligibilityReport } from 'utils/web_api'

const headers: Headers = [
  { label: 'First name', key: 'given_name' },
  { label: 'Last name', key: 'last_name' },
  { label: 'Eligible', key: 'eligible' },
  { label: 'Ineligible reason', key: 'ineligible_reason' },
  { label: 'Month', key: 'month' },
  { label: 'Referral fee', key: 'referral_fee' },
]

const DownloadEligibilityReportButton = ({
  partnerId,
  payoutId,
  employerName,
  month,
}: {
  partnerId: string
  payoutId: string
  employerName?: string
  month?: string
}) => {
  const csvLinkRef = useRef<CSVLink & HTMLAnchorElement & { link: HTMLAnchorElement }>(null)
  const [shouldFetch, setShouldFetch] = useState(false)
  const { data: memberEligibilities } = useGetPartnersPartnerIdPayoutsIdEligibilityReport(
    partnerId,
    payoutId,
    { query: { enabled: shouldFetch } }
  )

  // Transform data for CSV export - flatten referral_fee object to formatted string
  const csvData = memberEligibilities?.map((eligibility) => ({
    ...eligibility,
    referral_fee: eligibility.referral_fee.formatted_amount,
  })) ?? []

  const onClick = () => {
    setShouldFetch(true)

    window.segment?.track('[TfB] Eligibility report downloaded')
  }

  useEffect(() => {
    if (shouldFetch && memberEligibilities) {
      csvLinkRef.current?.link.click()
      setShouldFetch(false)
    }
  }, [shouldFetch, memberEligibilities])

  return (
    <>
      <IconButton
        onClick={onClick}
        icon={Download}
        label='Download Eligibility Report'
      />
      <CSVLink
        ref={csvLinkRef}
        data={csvData}
        headers={headers}
        filename={`eligibility_report_${employerName ?? ''}_${month ?? ''}.csv`}
        target='_blank'
        className='hidden'
      />
    </>
  )
}

export default DownloadEligibilityReportButton
